import { Input } from 'reactstrap'
import { publishEvent } from '../../utils'

export default function ActionTypeSelect({ handleChange }) {
  console.log('ActionTypeSelect rendered')

  function publishChange(e) {
    console.log('ActionTypeSelect: ', e.target.value)
    publishEvent('ACTION_TYPE_SELECTED', e.target.value, 'ActionTypeSelect')
  }

  const changeFunction = handleChange ? (e) => handleChange(e) : (e) => publishChange(e)

  return (

    <Input type="select" name="action-type" id="action-type" bsSize="sm" onChange={(e) => changeFunction(e)} style={{ width: 'auto' }}>
      <option key={1} value="1">SUBMIT</option>
      <option key={3} value="3">MODIFY</option>
      <option key={4} value="4">DELETE</option>
      <option key={2} value="2">CHANGE STATE</option>
    </Input>
  )
}